import { Controller } from 'stimulus';
import salvattore from 'salvattore';

class MasonryController extends Controller {
  recreateColumns() {
    salvattore.recreateColumns(this.element);
  }
}

MasonryController.targets = [
  //
];

export default MasonryController;
